import { Row, Col, Card, message, Typography, Upload, Form } from "../ui/ot";
import { useState, useEffect } from "react";
import SystemInformationFormV2 from "./views/system_information_form";
import { useWebsiteBasicInformation } from "./controller/WebsiteBasicInformationController";


const SystemInformationSetting = ({ prefixTitle = "", permission_level = null }) => {
    const [form] = Form.useForm();
    const [axiosMode, setAxiosMode] = useState("patch");

    const onFormFinish = (values) => {
        let newInformationData = values || []
        let classifyStructureTypeDatas = newInformationData?.classify_structure_type_data || []
        classifyStructureTypeDatas = classifyStructureTypeDatas.map((classifyStructureTypeData) => {
            let classifyStructureTypeFileDatas = (classifyStructureTypeData?.classify_structure_type_file_data || []).map((fileData) => {
                return {
                    file_id: fileData?.file_id,
                }
            })
            return {
                ...classifyStructureTypeData,
                classify_structure_type_file_data: classifyStructureTypeFileDatas
            }
        })
        let information_staff_datas = newInformationData?.information_staff_data || []
        let information_staff_datas_temp = newInformationData?.information_staff_data_temp || []
        information_staff_datas = information_staff_datas.map((information_staff_data) => {
            let information_staff_data_temp = information_staff_datas_temp.find((element) => {
                return element?.staff_id === information_staff_data?.staff_id
            })

            return {
                staff_id: information_staff_data?.staff_id,
                information_staff_id: information_staff_data_temp?.information_staff_id
            }
        })
        newInformationData = {
            ...newInformationData,
            classify_structure_type_data: classifyStructureTypeDatas,
            information_staff_data: information_staff_datas
        }
        if (axiosMode === "post") {
            // postWebsiteBasicInformationData([values]);
        } else if (axiosMode === "patch") {
            patchWebsiteBasicInformationData([newInformationData]);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("送出成功");
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                getWebsiteBasicInformationData();
                message.success("修改成功");
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                // actionRef.current.reloadAndRest();
                // setSelectedRowKeys([])
                // setSelectedRowsInfo([])
            }
            // setModalLoading(false)
            // setModalOpen(false)
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                getWebsiteBasicInformationData();
                message.error("修改失敗");
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                // actionRef.current.reloadAndRest();
            }
            // setModalLoading(false)
            // setModalOpen(false)＿＿＿＿
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    };
    const {
        WebsiteBasicInformationData,
        getWebsiteBasicInformationData,
        postWebsiteBasicInformationData,
        patchWebsiteBasicInformationData,
        communityData,
        getCommunityData,
        // deleteAppointmentData,
    } = useWebsiteBasicInformation({
        onFinish,
        onBefore,
    });

    useEffect(() => {
        WebsiteBasicInformationData.forEach((item) => {
            Object.keys(item).forEach((key) => {
                if (key !== "key") {
                    form.setValue(key, item[key]);
                }
                if (key === "information_staff_data") {
                    form.setValue("information_staff_data_temp", item[key]);
                }
            });
            // form.setFieldsValue(item);
        });
    }, [WebsiteBasicInformationData]);
    useEffect(() => {
        document.title = `${prefixTitle} | 網站設定`;

        getWebsiteBasicInformationData();
        getCommunityData();
    }, []);

    return (
        <Row
            gutter={[8, 8]}
        >
            <Col span={24} >
                {/* 主標題 */}
                <Typography.Title level={3}
                    style={{
                        color: "#333", // 深色文字
                        fontWeight: "700",
                        margin: "0",
                        lineHeight: "1.2",
                        borderBottomWidth: 0
                    }}
                >
                    網站基本資料設定
                </Typography.Title>
            </Col>
            <Col span={24}>
                <SystemInformationFormV2
                    propsForm={form}
                    onFormFinish={onFormFinish}
                    permission_level={permission_level}
                />
            </Col>
        </Row>
    );
};
export default SystemInformationSetting;
